(function($, Drupal, drupalSettings) {

  Drupal.behaviors.mbo_nav_003 = {
    attach: function (context, settings) {

      var scrollDisabled = false;
      var panelCount = 0;

      (function($) {
        $.fn.hasScrollBar = function() {
          return this.get(0).scrollHeight > this.height();
        }
      })(jQuery);

      function prepareScrollFades() {
        $('.nav-003-panel').each(function() {
          if($(this).hasScrollBar()) {
            $(this).find('.fade-bottom').fadeIn(300);
          } else {
            $(this).find('.fade-top').fadeOut(300);
            $(this).find('.fade-bottom').fadeOut(300);
            if($('.body').hasClass('os-Android')) {
              if($(this).find('.fade-bottom').is(':visible')) {
                $(this).find('.fade-bottom').addClass('hide()');
              }
            }
          }
        });
      }

      function disableScroll() {
        $.scrollLock(true);
      }

      function enableScroll() {
        $.scrollLock(false);
      }

      function scrollOverlapFix() {

        if($('.nav-003-panel.contact-panel').length > 0) {
          if ($('.nav-003-panel.contact-panel').hasScrollBar()) {
            $('.nav-003-contact-panel-notes').addClass('scroll-bar-fix');
          } else {
            $('.nav-003-contact-panel-notes').removeClass('scroll-bar-fix');
          }
        }
      }

      $('.webform-panel, .contact-panel, .document-panel').scroll(function() {

        var fadeBottom = $(this).find('.fade-bottom');
        var fadeTop = $(this).find('.fade-top');
        var isBottom = $(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight - 3;
        var scrollTop = $(this).scrollTop();

        if(!fadeBottom.is(':visible') && !isBottom) {
          fadeBottom.fadeIn(300);
        }

        if(scrollTop > 0 && !fadeTop.is(':visible')) {
          $(this).find('.fade-top').fadeIn(300);
        } else if(scrollTop === 0) {
          $(this).find('.fade-top').fadeOut(300);
        }

        if(isBottom) {
          fadeBottom.fadeOut(300);
          if($('.body').hasClass('os-Android')) {
            if(fadeBottom.is(':visible')) {
              fadeBottom.addClass('hide()');
            }
          }
        }

      });

      if ($('#overlay').length <= 0) {
        $("#page").once('nav-003-overlay').append('<div id=\'overlay\'></div>');
      }

      //Global triggers
      $('body').once('nav-003-anchor-contact-info').on('click', 'a[href="#contact-info"]', function() {
        $('[data-id="nav-003-contact"]').trigger('click');
        return false;
      });

      $('body').once('nav-003-anchor-contact-form').on('click', 'a[href="#contact-form"]', function() {
        $('[data-id="nav-003-webform"]').trigger('click');
        return false;
      });

      $('body').once('nav-003-anchor-document-form').on('click', 'a[href="#download-form"]', function() {
        $('[data-id="nav-003-document"]').trigger('click');
        return false;
      });

      /**
       * Open panel.
       */
      $('body').once('nav-003-cta-click').on('click', '.nav-003-cta, .nav-003-download', function() {

        disableScroll();

        $("#overlay").addClass("open z-index nav-003-overlay");
        $('#block-mbonav003').addClass('open-z-index');
        $('.nav-003-panel').removeClass('show');
        $('.nav-003-cta').removeClass('nav-003-active');
        $('.nav-003-download').removeClass('nav-003-active');
        $(this).addClass('nav-003-active');
        $('.nav-003-panel#' + $(this).attr('data-id')).addClass('show');
        $('.nav-003').removeClass('closed').addClass('open');

        if ($('.webform-panel').hasClass('show')) {
          $('.nav-003').addClass('webform-panel-open');
        } else {
          $('.nav-003').removeClass('webform-panel-open');
        }

        if ($('.contact-panel').hasClass('show')) {
          $('.nav-003').addClass('contact-panel-open');
        } else {
          $('.nav-003').removeClass('contact-panel-open');
        }

        scrollOverlapFix();
        prepareScrollFades();

      });

      /**
       * Close panel.
       */
      $('body').once('nav-003-close-cta-click').on('click', '.close-panel-section', function() {

        $("#overlay").removeClass("open");

        enableScroll();

        $('.nav-003').removeClass('open').addClass('closed');
        $('.nav-003-cta').removeClass('nav-003-active');
        $('.nav-003-download').removeClass('nav-003-active');
        setTimeout(function() {
          $('.nav-003-panel').removeClass('show');
          $('#block-mbonav003').removeClass('open-z-index');
          $("#overlay").removeClass("z-index nav-003-overlay");
        }, 400);
      });

      /**
       * Submit document download webform.
       */
      $('.document-download').once('document-download-click').on('click', function() {

        disableScroll();

        $("#overlay").addClass("open z-index nav-003-overlay");

        $('.document-panel .form-submit').click();
        prepareScrollFades();

      });

      $(window).ready(function() {

        if ($('.nav-003-confirmation').length > 0) {
          $('.nav-003-confirmation').closest('.nav-003-panel').addClass('show');
          $('.nav-003').addClass('open');

          if ($('.nav-003-confirmation').parent().hasClass('webform-submission-form') && !$('.nav-003-confirmation').parent().hasClass('webform-submission-nav-003-download-form')) {
            $('.webform-panel h3').not('.no-replace').hide();
          }

          if ($('.nav-003-confirmation').parent().hasClass('webform-submission-nav-003-download-form')) {

            if ($('.download-fallback').length <= 0) {
              $('.document-download').hide();
              $('.webform-submission-nav-003-download-form .nav-003-confirmation').append('<a href="' + $('.document-download').attr('data-document') + '" class="mba-button mba-button-download enabled download-fallback" style="position:relative; left:50%; transform: translateX(-50%)" target="_blank"> <div class="mba_btn_001a icon--doc021-white"> <span>Download the report</span><i></i></div> </a>');
              $('.document-panel-intro').hide();
              $('.document-details').hide();
              $('.nav-003-download').addClass('nav-003-active');

              var url = $('.document-download').attr('data-document');

              if (url.indexOf(".pdf") >= 0 || url.indexOf(".txt") >= 0) {
                window.open(url, '_blank');
              } else {
                window.location.href = url;
              }
            } else {
              $('.document-panel').removeClass('show');
              $('.webform-cta').addClass('nav-003-active');
            }
          }

          disableScroll();

          $("#overlay").addClass("open z-index nav-003-overlay");
          $('#block-mbonav003').addClass('open-z-index');
          $('.close-panel-section').css('display', 'inline-block');

          prepareScrollFades();

        }

        scrollOverlapFix();

        if (window.location.hash == '#contact-info' && !$('.nav-003').hasClass('open')) {
          $('.nav-003-ctas .contact-cta').trigger('click');
        }
        if (window.location.hash == '#contact-form' && !$('.nav-003').hasClass('open')) {
          $('.nav-003-ctas .webform-cta').trigger('click');
        }
        if (window.location.hash == '#download-form' && !$('.nav-003').hasClass('open')) {
          $('.nav-003-ctas .nav-003-download').trigger('click');
        }

        var obj = jQuery(context).find('.webform-submission-nav-003-download-node-1-form-ajax-content');

        if (obj.length > 0) {
          window.location.replace($('.document-download').attr('data-document'));
        }

        if ($('.document-panel').length > 0) {
          panelCount += 1;
        }

        if ($('.contact-panel').length > 0) {
          panelCount += 1;
        }

       if ($('.webform-panel').length > 0) {
         panelCount += 1;
       }

       if (panelCount !== 0) {
         $('.nav-003-panel-section').addClass('panel-count-' + panelCount);
       }

       if ($('.nav-003-contact-panel-notes').length > 0) {
         $('.nav-003-contact-panel-notes p').addClass('small');
       }
      });

      $(document).once('mbo-nav-overlay-click').ready(function() {

        $('.webform-panel, .document-panel, .contact-panel').niceScroll({
          autohidemode: 'leave',
          cursoropacitymax: 0.5,
          cursorwidth: '10px',
          railpadding: { top: 0, right: 1, left: 0, bottom: 0 },
        });

      });

      $(window).resize(function() {
        prepareScrollFades();
        scrollOverlapFix();
      });

      $("body").once('mbo-nav-overlay-click').on('click', '#overlay', function() {
        $('#overlay').removeClass('open');

        enableScroll();

        $('.nav-003').removeClass('open').addClass('closed');
        $('.nav-003-cta').removeClass('nav-003-active');
        $('.nav-003-download').removeClass('nav-003-active');
        setTimeout(function() {
          $("#overlay").removeClass("z-index nav-003-overlay");
          $('.nav-003-panel').removeClass('show');
          $('#block-mbonav003').removeClass('open-z-index');
        }, 400);
      });


      /**
      * Hide document download button when valid form is clicked.
      */

      $('.document-download', context).once('document-download-ajax-throbber').click(function() {

        if ( !$('form').hasClass('ajax-submit-prevented') ) $(this).hide();

      });


    }
  }; //Drupal.behaviors.mbo_nav_003



})(jQuery, Drupal, drupalSettings);
